import { getFilters } from "./filters";
import { getTodos, toggleTodo, removeTodo } from "./todos";

// Render application todos based on filters
const renderTodos = () => {
  const todosMainEl = document.querySelector("#todos");
  const filters = getFilters();
  const filteredTodos = getTodos().filter(todo => {
    const searchTextMatch = todo.text
      .toLowerCase()
      .includes(filters.searchText.toLowerCase());
    const hideCompletedMatch = !filters.hideCompleted || !todo.completed;

    return searchTextMatch && hideCompletedMatch;
  });

  const incompleteTodos = filteredTodos.filter(todo => !todo.completed);

  todosMainEl.innerHTML = "";
  todosMainEl.appendChild(generateSummaryDOM(incompleteTodos));

  if (filteredTodos.length) {
    filteredTodos.forEach(todo => {
      todosMainEl.appendChild(generateTodoDOM(todo));
    });
  } else {
    const emptyMessageEl = document.createElement("p");
    emptyMessageEl.textContent = "No to-dos to show!!";
    emptyMessageEl.classList.add("empty-message");
    todosMainEl.appendChild(emptyMessageEl);
  }
};

// Get the DOM elements for an individual note
const generateTodoDOM = todo => {
  const todoEl = document.createElement("label");
  const containerEl = document.createElement("div");
  const checkbox = document.createElement("input");
  const todoText = document.createElement("span");
  const removeButton = document.createElement("button");

  // Setup todo checkbox
  checkbox.setAttribute("type", "checkbox");
  containerEl.appendChild(checkbox);
  if (todo.completed) {
    checkbox.setAttribute("checked", "true");
  }
  // Other way to implement the above functionality
  // checkbox.checked = todo.completed;
  checkbox.addEventListener("change", () => {
    toggleTodo(todo.id);
    renderTodos();
  });

  // Setup the todo text
  todoText.textContent = todo.text;
  containerEl.appendChild(todoText);

  // Setup container
  todoEl.classList.add("list-item");
  containerEl.classList.add("list-item__container");
  todoEl.appendChild(containerEl);

  // Setup the remove button
  removeButton.textContent = "remove";
  removeButton.classList.add("button", "button--text");
  todoEl.appendChild(removeButton);
  removeButton.addEventListener("click", () => {
    removeTodo(todo.id);
    renderTodos();
  });
  return todoEl;
};

// Get the DOM elements for list summary
const generateSummaryDOM = incompleteTodos => {
  const summary = document.createElement("h2");
  summary.classList.add("list-title");
  let pluralizedText = incompleteTodos.length === 1 ? "" : "s";
  summary.textContent = `You have ${
    incompleteTodos.length
  } todo${pluralizedText} left`;
  return summary;
};

export default renderTodos;
